/**
 * Domain (category) color assignment for the knowledge graph.
 * Fixed 8-hue categorical order (same convention as chartTheme.ts):
 * light-mode literals for categorical fills. The rest of the graph chrome
 * uses theme tokens so labels/edges/controls flip with dark mode.
 */
const DOMAIN_HUES = [
  '#2a78d6', // blue
  '#eb6834', // orange
  '#1baf7a', // aqua
  '#eda100', // yellow
  '#e87ba4', // magenta
  '#008300', // green
  '#4a3aa7', // violet
  '#e34948', // red
] as const

/** Past the 8 declared hues, fold into muted ink rather than cycling a hue. */
export const DOMAIN_OTHER = 'var(--color-text-3)'

/** `domains` must be the backend's ordered list — slot assignment is by
 * position in that order, not alphabetical. */
export function domainColorScale(
  domains: string[],
): (domain: string) => string {
  const map = new Map(
    domains.map((d, i) => [d, DOMAIN_HUES[i % DOMAIN_HUES.length]]),
  )
  return (domain: string) => map.get(domain) ?? DOMAIN_OTHER
}
